module.exports = __webpack_public_path__ + "static/contact3-8aca6ef9a0d1c51ce05c159610a072dd.jpg";